<template>
    <div>
        <PageTable hideExport hideTitle @selection-change="seChoose" ref="dataTable" :auto-load="true" :data="dataTable"
                   @load-data="dataTableLoad" highlight-current-row stripe border>
            <el-table-column type="selection" align="center"></el-table-column>
<!--            <el-table-column label="接收配置标识" prop="rconfigdefn" show-overflow-tooltip align="center"></el-table-column>-->
            <el-table-column label="发送用户身份(SenderId)" prop="rsenderdefn" show-overflow-tooltip width="200" align="center"></el-table-column>
            <el-table-column label="传输接收协议" prop="rreceiverconndefn" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column label="责任链" prop="rrcdefn" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column label="本地接收协议" prop="rsenderconndefn" show-overflow-tooltip align="center"></el-table-column>
            <!-- <el-table-column label="线程数" prop="rcscnnum" show-overflow-tooltip width="60"></el-table-column> -->
            <el-table-column label="路由类型" prop="scfdefn" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="csstatus" label="运行状态" show-tooltip-when-overflow align="center">
                <template slot-scope="{ row }">
                    <el-tag v-if="row.csstatus === '-1'">初始化失败</el-tag>
                    <el-tag v-else-if="row.csstatus === '0'">未初始化</el-tag>
                    <el-tag v-else-if="row.csstatus === '1'">初始化成功</el-tag>
                    <el-tag v-else-if="row.csstatus === '2'">已启动</el-tag>
                    <el-tag v-else-if="row.csstatus === '-2'">已停用</el-tag>
                    <el-tag v-else-if="row.csstatus === '-3'">已停止</el-tag>
                    <el-tag v-else>初始化</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" show-overflow-tooltip width="180" align="center">
                <template slot-scope="scope">
                    <el-button title="编辑" class="blue" icon="el-icon-fa-edit" @click="edit(scope.$index, scope.row)">编辑</el-button>
                    <el-button title="开始" class="green" icon="el-icon-fa-play" @click="startRes(scope.$index, scope.row)">开始</el-button>
                    <el-button title="停止" class="red" icon="el-icon-fa-stop" @click="stopRes(scope.$index, scope.row)">停止</el-button>
                </template>
            </el-table-column>
        </PageTable>
    </div>
</template>
<script>
import idApi from "@/api/senior/idApi.js";
import monitorApi from "@/api/senior/monitorApi";

export default {
    props: {
        receUuid: ""
    },
    data() {
        return {
            dataTable: [],
            multipleSelection: []
        };
    },
    methods: {
        seChoose(val) {
            this.multipleSelection = val;
        },
        edit(index, row) {
            this.$emit("editRece", {row});
        },
        doSeleDel() {
            if (this.multipleSelection.length !== 0) {
                this.$confirm("是否删除该条数据", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let array = [];
                    this.multipleSelection.forEach((value, index) => {
                        array.push(value.uuid);
                    });
                    idApi.delRc(array).then(() => {
                      this.reload();
                        monitorApi
                            .select()
                            .then(respData =>
                                this.$store.dispatch("client/loadMonTableData", respData.datarows)
                            );
                    });
                });
            } else {
                this.$message({
                    message: "请选择数据！",
                    type: "warning"
                });
            }

        },
        dataTableLoad(params, resole) {
            let str = {ai_uuid: this.receUuid};
            idApi
                .selectRece(Object.assign(str, params))
                .then(resole)
                .then(respData => (this.dataTable = respData.datarows));
        },
        reload(){
          this.$refs.dataTable.load();
        },
        startAllRece() {
            let array = [];
            this.dataTable.forEach((value, index) => {
                array.push(value.uuid);
            });
            idApi.identityResStartByuuid(array).then(() => {
                this.$refs.dataTable.load();
            });
        },
        stopAllRece() {
            let array = [];
            this.dataTable.forEach((value, index) => {
                array.push(value.uuid);
            });
            idApi.identityResStopByuuid(array).then(() => {
                this.$refs.dataTable.load();
            });
        },
        startRes(index, row) {
            let array = [];
            array.push(row.uuid);
            idApi.identityResStartByuuid(array).then(() => {
                this.$refs.dataTable.load();
            });
        },
        stopRes(index, row) {
            let array = [];
            array.push(row.uuid);
            idApi.identityResStopByuuid(array).then(() => {
                this.$refs.dataTable.load();
            });
        },
    }
};
</script>
